import { useMutation, useQueryClient } from 'react-query';
import { getProfessionKeys } from './professionQueries';
import { trpc } from '../../../../lib/trpc';

const useAddProfession = () => {
    const client = useQueryClient();
    return useMutation(
        async ({ name }: { name: string }) => {
            return trpc.ProfessionApi.createProfession.query({ name });
        },
        {
            onSettled: () => {
                client.invalidateQueries(getProfessionKeys.lists());
            }
        }
    );
};

export default useAddProfession;
